import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Subscription } from "rxjs";

@Component({
  selector: "app-lineitem-filter",
  templateUrl: "./lineitem-filter.component.html",
  styleUrls: ["./lineitem-filter.component.scss"],
})
export class LineitemFilterComponent {
  @Input() options;
  @Input() selectedOptionsId;
  @Input() selectedValue;
  @Input() liFilterId;
  @Input() label;
  @Input() placeholder = "Add Line Items";
  @Input() bottomBorderView;
  @Input() disabled;
  @Input() showLabel = false;
  @Input() showButton;
  @Input() cascaderClass;
  @Input() isLIMModal;
  @Input() tickers;
  @Output() onInputChange = new EventEmitter();
  @Output() onValueChange = new EventEmitter();
  @Output() onEditButtonClick = new EventEmitter();

  formattedOptions = [];
  filteredOptions = [];
  searchedText = "";
  values;
  resultedValues;
  apiEP: string = window.apiUrl;
  suggestedLineItemMenuName = "Suggested Line Items";

  limSearchLineSubscriber: Subscription;

  constructor(private http: HttpClient) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.options &&
        changes.options.currentValue !== changes.options.previousValue) ||
      (changes.selectedOptionsId &&
        changes.selectedOptionsId.currentValue !==
          changes.selectedOptionsId.previousValue)
    ) {
      this.formattedOptions = this.getFormattedOptions(this.options);
      if (this.searchedText) {
        this.getFilteredOptions(this.searchedText);
      } else {
        this.filteredOptions = this.formattedOptions
          ? [...this.formattedOptions]
          : [];
      }
    }
  }

  getFormattedOptions(data) {
    if (!data || !data.length) {
      return [];
    }
    let seletectParentChildValues = [];
    const formattedOptions = data.map((item) => {
      const childrenOfLi = item.tab_sli_data.map((el) => {
        const value = el.uniquesliid || el.sli_id || el.id;
        const isSelected = (this.selectedOptionsId || []).includes(value);
        if (isSelected) {
          const isSuggestedLineItemSelceted =
            item.tab_full_name === this.suggestedLineItemMenuName;
          if (
            isSuggestedLineItemSelceted &&
            seletectParentChildValues[0] !== this.suggestedLineItemMenuName
          ) {
            seletectParentChildValues = [this.suggestedLineItemMenuName, value];
          } else if (seletectParentChildValues.length === 0) {
            seletectParentChildValues = [item.tab_full_name, value];
          }
        }
        return {
          value: value,
          uniquesliid: value,
          sli_id: value,
          id: value,
          label: el.name,
          name: el.name,
          subText: el.line_count,
          disabled: isSelected,
          line_count: el.line_count,
          children: [],
          isLeaf: true,
          prefixIcon: isSelected ? "check" : undefined,
          isSelected,
        };
      });
      const formattedObj = {
        value: item.tab_full_name,
        label: item.tab_full_name,
        tab_short_name: item.tab_short_name,
        subText: childrenOfLi.length || undefined,
        disabled: false,
        children: childrenOfLi,
        isLeaf: !childrenOfLi.length,
      };
      return formattedObj;
    });

    this.values = seletectParentChildValues;
    this.resultedValues = seletectParentChildValues;
    return formattedOptions;
  }

  getFilteredOptions(searchTerm: string) {
    let output = [];
    const formattedSearchTerm = searchTerm && searchTerm.trim().toLowerCase();
    if (
      formattedSearchTerm &&
      this.formattedOptions &&
      this.formattedOptions.length
    ) {
      let seletectParentChildValues = null;
      for (const item of this.formattedOptions) {
        const currentChild = item.children;
        const tabId = item.tab_short_name;
        const searchedItems = [];
        if (tabId === "SL") {
          continue;
        }
        for (const childItem of currentChild) {
          const formattedTargetTerm = childItem.label.trim().toLowerCase();
          if (formattedTargetTerm.includes(formattedSearchTerm)) {
            searchedItems.push(childItem);
          }
        }

        const searchItemLength = searchedItems.length;
        if (searchItemLength) {
          const currentResult = {
            ...item,
            subText: searchedItems.length,
            children: searchedItems,
          };
          output.push(currentResult);
          if (!seletectParentChildValues) {
            seletectParentChildValues = [
              currentResult.label,
              currentResult.children[0].value,
            ];
          }
        }
      }
      if (output && output.length) {
        this.resultedValues = seletectParentChildValues;
      }
    } else {
      output = [...this.formattedOptions];
      this.resultedValues = this.values;
    }

    return output;
  }

  handleLIMServerSearch(searchTerm) {
    const formattedSearchTerm = searchTerm && searchTerm.trim();
    if (formattedSearchTerm) {
      const ticker =
        this.tickers && this.tickers.length ? `ticker=${this.tickers[0]}` : "";
      this.limSearchLineSubscriber = this.http
        .get(
          `${
            this.apiEP
          }/api/search_lines?${ticker}&monitoring=true&search_query=${encodeURIComponent(
            formattedSearchTerm,
          )}`,
        )
        .subscribe((lineitemData: Array<any>) => {
          // TODO: get the newly formatted response from BE, so we dont have to format it on FE
          const output = [];
          if (lineitemData) {
            let seletectParentChildValues = null;
            for (let i = 0; i < lineitemData.length; i++) {
              if (i === 0) {
                continue;
              }
              const item = lineitemData[i];
              const childrenOfLi = [];
              for (let j = 0; j < item.children.length; j++) {
                if (j === 0) {
                  continue;
                }
                const el = item.children[j];
                const value = el.id;
                const isSelected = (this.selectedOptionsId || []).includes(
                  value,
                );
                const formattedChild = {
                  value: value,
                  uniquesliid: value,
                  sli_id: value,
                  id: value,
                  label: el.label,
                  name: el.label,
                  subText: el.line_count,
                  disabled: isSelected,
                  line_count: el.line_count,
                  children: [],
                  isLeaf: true,
                  prefixIcon: isSelected ? "check" : undefined,
                  isSelected,
                };
                childrenOfLi.push(formattedChild);
              }

              const formattedObj = {
                value: item.tabshortname,
                label: item.label,
                tab_short_name: item.tabshortname,
                subText: childrenOfLi.length || undefined,
                disabled: false,
                children: childrenOfLi,
                isLeaf: !childrenOfLi.length,
              };
              output.push(formattedObj);
              if (!seletectParentChildValues) {
                seletectParentChildValues = [
                  formattedObj.value,
                  formattedObj.children[0].value,
                ];
              }
            }
            if (output && output.length) {
              this.resultedValues = seletectParentChildValues;
            }
          }
          this.filteredOptions = output;
        });
    } else {
      this.filteredOptions = [...this.formattedOptions];
      this.resultedValues = this.values;
    }
  }

  handleInputChange(item) {
    this.searchedText = item;
    if (this.isLIMModal) {
      this.handleLIMServerSearch(item);
    } else {
      this.filteredOptions = this.getFilteredOptions(item);
    }
  }

  handleEditButtonClick() {
    this.onEditButtonClick.emit();
  }

  handleValueChange(item) {
    this.searchedText = "";
    this.onValueChange.emit(item[1]);
  }

  ngOnDestroy() {
    if (this.limSearchLineSubscriber) {
      this.limSearchLineSubscriber.unsubscribe();
    }
  }
}
